"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSessionId = void 0;
var user_feedback_common_1 = require("@wix/user-feedback-common");
exports.getSessionId = function () { return user_feedback_common_1.getRandomGuid4(); };
//# sourceMappingURL=session-id-provider.js.map